import superagent from 'superagent';

import config from '../data/config';

const responseBody = (res) => res.body;

export const Agent = ({ getToken, handleErrors }) => {

    const tokenPlugin = (req) => {
        const token = getToken();
        req.set('Access-Control-Allow-Origin', "*");
        req.set('X-Requested-With', 'XMLHttpRequest');
        if (token) req.set('X-Authorization', `${token}`);
    };

    return {

        /** method: GET */
        get: (path) =>
            superagent
                .get(`${config.api}${path}`)
                .use(tokenPlugin)
                .then(responseBody)
                .catch(handleErrors),

        /** method: PUT */
        put: (path, body) =>
            superagent
                .put(`${config.api}${path}`, body)
                .use(tokenPlugin)
                .then(responseBody)
                .catch(handleErrors),

        /** method: POST */
        post: (path, body) =>
            superagent
                .post(`${config.api}${path}`)
                .send(body)
                .use(tokenPlugin)
                .then(responseBody)
                .catch(handleErrors),

        /** method: DELETE */
        delete: (path, body) =>
            superagent
                .delete(`${config.api}${path}`, body)
                .use(tokenPlugin)
                .then(responseBody)
                .catch(handleErrors),
                
    };
};

export const encode = encodeURIComponent;
